import { getATLContextUrl } from '@atlaskit/atlassian-context';

import { canvasFrameAPI } from '@canvas/frame-api/host-api/host-frame-context';

export const getViewProfileUrl = (accountId: string) =>
  `/wiki/people/${accountId}?ref=confluence`;

export const getTeamCentralBaseUrl = (orgId?: string, siteId?: string) => {
  const teamCentralBaseUrl = getATLContextUrl('home');
  let suffix = '';
  if (orgId) {
    suffix = `/o/${orgId}`;
  }
  if (siteId) {
    suffix += `/s/${siteId}`;
  }
  return `${teamCentralBaseUrl}${suffix}`;
};

export const getGiveKudosUrl = (siteId?: string, accountId?: string) => {
  const orgId = canvasFrameAPI?.getOrgId?.();
  const teamCentralBaseUrl = getTeamCentralBaseUrl(orgId, siteId);
  const recipientId = accountId ? `&recipientId=${accountId}` : '';
  const cloudIdParam = siteId ? `&cloudId=${siteId}` : '';
  return `${teamCentralBaseUrl}/kudos/give?type=individual${recipientId}${cloudIdParam}`;
};
